import { setupFareAdapterElementForm, setupRecurrenceRulesFormButtons } from '../../lib/form_helpers';
import setupFareAdapterElementModal from '../../lib/fare_adapter_element_modal';

const ManagementFareAdapterConfigurations = {
  init() {
    setupRecurrenceRulesFormButtons();
    setupFareAdapterElementForm();
    setupFareAdapterElementModal();
  }
};

export default ManagementFareAdapterConfigurations;
